type GeneralErrorProps = {
  message: string;
};

const GeneralError = ({ message }: GeneralErrorProps) => {
  return <div className="text-red-600 font-bold text-center mt-2">{message}</div>;
};

export default GeneralError;
